export default __webpack_public_path__ + "static/results-screen-509b27ef33a5bac3e3a76b5535c78e94.webp";